/**
 * @generated SignedSource<<0cf4d2d584d9c3826dce2e348c200d6e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphQLJobTaskType = "AGENT" | "AGENT_DASHBOARD_SNAPSHOT" | "ALERT_INSIGHTS" | "ALERT_RESPONDER" | "ALERT_THREAD_LEARNING" | "AWS_MARKETPLACE_METERING" | "BITBUCKET_TOKEN_REFRESH" | "BUILDKITE_SYNC" | "CODE_PULL" | "CREDITS_COMPUTATION_V2" | "CTA_REMINDER" | "CUSTOMER_AGENT_IMAGE_BUILD" | "CUSTOMER_AGENT_SANDBOX_IMAGE_CACHE" | "CUSTOM_MCP_SERVER_TOOL_REFRESH" | "DAG_AGENT" | "DATABRICKS_MEMORY_INGESTION" | "DATABRICKS_SYNC" | "DATABRICKS_TO_POSTGRES_SYNC" | "DIGEST" | "GENERIC_LEARNING" | "GITHUB_CODEBASE_ANALYSIS" | "GITLAB_TOKEN_REFRESH" | "GRAFANA_CLOUD_DATASOURCE_SYNC" | "INCIDENT_CHANNEL_LEARNING" | "INCIDENT_DAG_AGENT" | "INCIDENT_KNOWLEDGE_SYNC" | "INGEST_SLACK_CHANNEL" | "NEWRELIC_APPLICATION_SYNC" | "ONBOARDING" | "ONBOARDING_QUESTION_TRAINING" | "PRODUCT_ANALYTICS" | "RESOURCE_FILES_SYNC" | "RESOURCE_SYNC_QUEUE" | "SLACK_CACHE_REFRESH" | "SLACK_USERGROUP_REFRESH" | "SNAPSHOT_CLEANUP" | "SUPPORT_AGENT_METRIC_CALCULATOR" | "SUPPORT_INSTRUCTION_GENERATION" | "TEAM_INSTRUCTION_GENERATION" | "WHAT_TIME_IS_IT_RIGHT_NOW" | "WORKFLOW_INVESTIGATION" | "WORKFLOW_MEMORY_CONSOLIDATION" | "WORKFLOW_MEMORY_EVAL_RECONCILER" | "%future added value";
export type CreateJobInput = {
  alertId?: any | null | undefined;
  inputJson?: any | null | undefined;
  name: string;
  notificationIntegrationIds?: ReadonlyArray<any> | null | undefined;
  schedule?: any | null | undefined;
  slackChannelIds?: ReadonlyArray<string> | null | undefined;
  taskType: GraphQLJobTaskType;
  teamId: any;
};
export type CreateDigestWizardMutation$variables = {
  input: CreateJobInput;
};
export type CreateDigestWizardMutation$data = {
  readonly createJob: {
    readonly job: {
      readonly id: any;
      readonly name: string;
    };
  };
};
export type CreateDigestWizardMutation = {
  response: CreateDigestWizardMutation$data;
  variables: CreateDigestWizardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateJobPayload",
    "kind": "LinkedField",
    "name": "createJob",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLJob",
        "kind": "LinkedField",
        "name": "job",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateDigestWizardMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateDigestWizardMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1c7aa600930709b1129ea2a52174f9cd",
    "id": null,
    "metadata": {},
    "name": "CreateDigestWizardMutation",
    "operationKind": "mutation",
    "text": "mutation CreateDigestWizardMutation(\n  $input: CreateJobInput!\n) {\n  createJob(input: $input) {\n    job {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8deaf8fec367a9e49c5d69a149e89d0e";

export default node;
